<template>
  <el-dialog :visible.sync="dialogVisible" width="70%" center>
    <div slot="title">
      <button type="button" class="el-dialog__headerbtn" @click="dialogVisible = false">
        <i class="el-dialog__close el-icon-close"></i>
      </button>
    </div>
    <el-row :gutter="20">
      <el-col :span="12" class="border-right">
        <div class="text-center">
          {{ $t('selectStaff.orgInfo') }}
        </div>
        <div class="staff-content">
          <org-tree-show ref="orgTreeShow" @switchOrg="loadStaff"></org-tree-show>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="text-center">
          {{ $t('selectStaff.staffInfo') }}
        </div>
        <div class="staff-content">
          <div v-for="(item, index) in selectStaffInfo.staffs" :key="index" @click="_changeStaff(item)"
            :class="{ 'selected': selectStaffInfo.curStaffId == item.staffId }" class="staff-item">
            <div>
              <i class="el-icon-user margin-right-xs"></i>
              {{ item.name }}
            </div>
            <div>{{ item.tel }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { queryStaffInfos } from '@/api/goods/staffApi'
import OrgTreeShow from '@/components/frame/orgTreeShow'

export default {
  name: 'SelectStaff',
  components: {
    OrgTreeShow
  },
  data() {
    return {
      dialogVisible: false,
      selectStaffInfo: {
        staffs: [],
        curStaffId: '',
        staff: {}
      }
    }
  },
  methods: {
    open(staff) {
      this.selectStaffInfo.staff = staff
      this.dialogVisible = true
      this.$refs.orgTreeShow.refreshTree()
    },
    async loadStaff(param) {
      try {
        const res = await queryStaffInfos({
          orgId: param.orgId,
          page: 1,
          row: 50
        })
        this.selectStaffInfo.staffs = res.data
        if (this.selectStaffInfo.staffs.length > 0) {
          this.selectStaffInfo.curStaffId = this.selectStaffInfo.staffs[0].staffId
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _changeStaff(item) {
      this.selectStaffInfo.staff.staffId = item.userId
      this.selectStaffInfo.staff.staffName = item.name
      this.dialogVisible = false
      if (this.selectStaffInfo.staff.call) {
        console.log(this.selectStaffInfo.staff)
        this.selectStaffInfo.staff.call(this.selectStaffInfo.staff)
      }
    }
  }
}
</script>

<style scoped>
.border-right {
  border-right: 1px solid #eee;
}

.staff-content {
  padding: 10px;
  height: 400px;
  overflow-y: auto;
}

.staff-item {
  padding: 10px;
  cursor: pointer;
}

.staff-item:hover,
.selected {
  background-color: #f5f7fa;
}

.margin-right-xs {
  margin-right: 5px;
}

.text-center {
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
}
</style>